import { Dialog, type DialogProps } from '@mui/material';
import { color } from '@/colors';

const dialogSx = {
  '& .MuiDialog-paper': {
    backgroundImage: 'none',
    borderRadius: '8px',
    border: `1px solid ${color.White08_T}`,
  },
};

export function AppDialog({ sx, ...props }: DialogProps) {
  return <Dialog sx={{ ...dialogSx, ...sx }} {...props} />;
}
